import React from 'react';

interface TitleProps {
    img: any,
    title: string,
}

const Title: React.FC<TitleProps> = ({ img, title }) => {
    return (
        <div>
            <div className='text-center'>
                <img src={img} alt='Icon' style={{ width: '200px', marginTop: '1em' }} />
            </div>

            <br />
            <h3 style={{ textAlign: 'center' }}>{title}</h3>
            <hr />
        </div>
    );
}

export default Title;